import { defineMessages } from 'react-intl';

/** The copy of "Which song is this cover for?" (design cover-editor g4). */
export const coverCarryMessages = defineMessages({
  title: { id: 'app.sml.coverEditor.carry.title', defaultMessage: 'Which song is this cover for?' },
  text: {
    id: 'app.sml.coverEditor.carry.text',
    defaultMessage: 'Your design from the artwork maker comes with you. Pick the song, and it opens in the editor.',
  },
  textNoSong: {
    id: 'app.sml.coverEditor.carry.textNoSong',
    defaultMessage: 'Your design from the artwork maker comes with you. Add your song first, then pick it here.',
  },
  addRelease: { id: 'app.sml.coverEditor.carry.addRelease', defaultMessage: 'Add a release' },
  putting: { id: 'app.sml.coverEditor.carry.putting', defaultMessage: 'Opening your design…' },
  failed: {
    id: 'app.sml.coverEditor.carry.failed',
    defaultMessage: 'Your design did not go to this song. Try again.',
  },
});
